import { Draw } from "ol/interaction";
import { createBox } from "ol/interaction/Draw";
import { Style, Fill, Stroke } from "ol/style";
import CircleStyle from "ol/style/Circle";
import GeometryType from "ol/geom/GeometryType";
import { BaseInteraction } from "../../lib/interaction/interactions";
import { Maybe, Some } from "../../lib/misc/option";
import { ToolMessage } from "../messages/ToolMessage";
export class ZoomInteraction extends BaseInteraction {
    constructor(map, layer) {
        super();
        this.map = map;
        this.layer = layer;
        this.name = 'zoom';
        this.enter_context = new Some('toolbar');
        this.exit_context = new Some('revert');
        this.draw = this.create_draw();
    }
    get geometric() { return true; }
    init() {
        super.init();
        this.interactions.push(this.draw);
        new ToolMessage({ selected: true, tool: this.name, command: "TOOL SELECTION" }).send();
    }
    remove() {
        super.remove();
        new ToolMessage({ selected: false, tool: this.name, command: "TOOL SELECTION" }).send();
    }
    create_draw() {
        const draw = new Draw({
            type: GeometryType.CIRCLE,
            geometryFunction: createBox(),
            source: this.layer.source,
            style: new Style({
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 0.6)'
                }),
                stroke: new Stroke({
                    color: 'rgba(255, 204, 51, 0.5)',
                    lineDash: [10, 10],
                    width: 2
                }),
                image: new CircleStyle({
                    radius: 5,
                    stroke: new Stroke({
                        color: 'rgba(255, 204, 51, 0.7)'
                    }),
                    fill: new Fill({
                        color: 'rgba(255, 255, 255, 0.6)'
                    })
                })
            })
        });
        draw.on('drawend', this.draw_end_handler.bind(this));
        return draw;
    }
    draw_end_handler(evt) {
        let sketch = evt.feature;
        const geo = Maybe(sketch.getGeometry());
        geo.map(geometry => {
            this.map.view.fit(geometry.getExtent(), { padding: [20, 20, 20, 20] });
            setTimeout(() => this.layer.clear(), 20);
        });
    }
}
